import styled from "styled-components";
import {
  BASIC_BROWN,
  BASIC_DARK_GRAY,
  BASIC_GRAY,
  BASIC_ORANGE,
  BASIC_WHITE,
} from "../../../constants/colors";
import { CouponExternal } from "../../../ducks/coupon";
import { useAsset } from "../../../hooks/useAsset";

type Props = {
  coupon: CouponExternal;
  isUsed: boolean;
  usedAmount: number;
  onUse: () => void;
};

export const AppCouponItem: React.FC<Props> = ({
  coupon,
  isUsed,
  usedAmount,
  onUse,
}) => {
  const { baseDir } = useAsset();
  return (
    <CouponItemContainer $isUsed={isUsed} onClick={onUse}>
      <CouponContent>
        <CouponImage
          src={coupon.imageUrl || baseDir + "/assets/images/menu_dummy@2x.jpg"}
          alt={coupon.name}
        />
        <CouponDetail>
          <CouponName $isUsed={isUsed}>{coupon.name}</CouponName>
          <CouponSelectionStatus $isUsed={isUsed}>
            {usedAmount > 0 ? `${usedAmount}枚 適用済み` : "このクーポンを使う"}
          </CouponSelectionStatus>
        </CouponDetail>
      </CouponContent>
    </CouponItemContainer>
  );
};

const CouponItemContainer = styled.div<{ $isUsed?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
  background-color: ${BASIC_WHITE};
  max-width: 600px;
  cursor: pointer;
`;

const CouponContent = styled.div`
  display: flex;
  width: 100%;
  gap: 14px;
`;

const CouponImage = styled.img`
  object-fit: cover;
  border: 1px solid ${BASIC_GRAY};
  width: 70px;
  height: 70px;
`;

const CouponDetail = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
`;

const CouponName = styled.div<{ $isUsed?: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${({ $isUsed }) => ($isUsed ? BASIC_ORANGE : BASIC_DARK_GRAY)};
  padding: 5px;
`;

const CouponSelectionStatus = styled.div<{ $isUsed?: boolean }>`
  font-size: ${({ $isUsed }) => ($isUsed ? "12px" : "10px")};
  background-color: ${({ $isUsed }) => ($isUsed ? BASIC_ORANGE : BASIC_BROWN)};
  color: ${BASIC_WHITE};
  text-align: center;
  width: 100%;
  padding: 4px 0;
  box-sizing: border-box;
  line-height: 100%;
`;
